import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getStringProp } from '@mews/fp';

import { getEntities } from '../getEntities';

const getRateGroups = createSelector(getEntities, get('rateGroups'));

const getRateGroup = createSelector(getStringProp('rateGroupId'), getRateGroups, get);

export const getRateGroupSettlementCurrencyCode = flow(getRateGroup, get('settlementCurrencyCode'));
